/**
 * Confined Waters Checklist
 * Rivers, harbours, narrow channels
 * Regulatory: COLREGs, Local Regs
 */

export const CONFINED_WATERS_CHECKLIST = {
  id: 'confined_waters',
  name: 'Confined Waters',
  description: 'Rivers, harbours, narrow channels',
  icon: 'Navigation',
  regulatory: 'COLREGs, Local Regs',
  isCustomisable: true,
  items: [
    { id: 'cw_1', text: 'Charts and publications for area available', required: true },
    { id: 'cw_2', text: 'VTS/Port Control contacted if required', required: true },
    { id: 'cw_3', text: 'Anchor ready for immediate use', required: true },
    { id: 'cw_4', text: 'Speed appropriate for conditions', required: true },
    { id: 'cw_5', text: 'Lookout posted', required: true },
    { id: 'cw_6', text: 'Sound signals ready', required: false }
  ]
};
